import React from "react";
import Header from "../Landing/components/Header";
import Footer from "../Landing/components/Footer";
import helpStyles from './HelpFaqPage.module.css';
import styles from '../Landing/LandingPage.module.css';

const HelpFaq = () => {
    return (
        <>
            <Header />
            <main>
                <section className={`${helpStyles.hero} ${helpStyles.heroPrivacy}`}>
                    <div className={styles.container}>
                        <div className={helpStyles.heroContent}>
                            <h1>Help & FAQ</h1>
                            {/* <p>We're here to help you with any questions about posting jobs, finding professionals, or using our platform.</p> */}
                        </div>
                    </div>
                </section>
                
                <section className={helpStyles.privacyWrapper}>

                    <div className={helpStyles.policySection}>
                        <h2>For Homeowners & Developers</h2>

                        <div className={helpStyles.faqItem}>
                            <h3>What is Build Start?</h3>

                            <p>
                                Build Start is a curated directory designed to connect you
                                with licensed and vetted construction professionals across Australia.
                                We help you find the right team for everything from small renovations
                                to major builds.
                            </p>
                        </div>

                        <div className={helpStyles.faqItem}>
                            <h3>What does the "Verified Pro" badge mean?</h3>

                            <p>
                                When you see the Verified Pro badge, it means we have manually checked
                                that professional’s trade licenses, business registration (ABN),
                                and insurance documents.
                            </p>

                            <p>
                                We do the homework so you can hire with peace of mind.
                            </p>
                        </div>

                        <div className={helpStyles.faqItem}>
                            <h3>How much does it cost to use Build Start?</h3>

                            <p>
                                For homeowners and developers, the platform is completely free.
                                You can browse the directory and contact professionals at no cost.
                            </p>
                        </div>

                        <div className={helpStyles.faqItem}>
                            <h3>What happens if I’m not happy with a contractor’s work?</h3>

                            <p>
                                Build Start connects you with professionals but is not a party
                                to your building contract.
                            </p>

                            <p>
                                We recommend discussing concerns directly with your contractor first.
                                If you cannot reach a resolution, you can contact your state's
                                building authority such as NSW Fair Trading or VBA.
                            </p>

                            <p>
                                Please also report the professional to us so we can review
                                their Verified status.
                            </p>
                        </div>
                    </div>

                    <div className={helpStyles.policySection}>
                        <h2>For Professionals (Pros)</h2>

                        <div className={helpStyles.faqItem}>
                            <h3>How do I get the "Verified Pro" badge?</h3>

                            <p>
                                After creating your profile, upload your current trade license,
                                ABN, and Public Liability Insurance certificate.
                            </p>

                            <p>
                                Our team reviews these documents within 2–3 business days.
                                Once approved, the badge will appear on your profile.
                            </p>
                        </div>

                        <div className={helpStyles.faqItem}>
                            <h3>How do leads work?</h3>

                            <p>
                                When a user is interested in your services, they can message you
                                directly or request a quote.
                            </p>

                            <p>
                                You will receive a notification through the app or email
                                so you can respond quickly.
                            </p>
                        </div>

                        <div className={helpStyles.faqItem}>
                            <h3>What is your refund policy for subscriptions?</h3>

                            <p>
                                Subscriptions are generally non-refundable because they provide
                                immediate access to our platform and Verified branding.
                            </p>

                            <p>
                                If you believe there has been a billing error,
                                contact us at{" "}
                                <a
                                    href="mailto:help@buildstart.au"
                                    className={helpStyles.link}
                                >
                                    help@buildstart.au
                                </a>{" "}
                                within 7 days.
                            </p>
                        </div>

                        <div className={helpStyles.faqItem}>
                            <h3>Can I cancel my membership at any time?</h3>

                            <p>
                                Yes. You can cancel your professional subscription
                                through your account settings.
                            </p>

                            <p>
                                You will continue to have access to your Pro features
                                until the end of your current billing cycle.
                            </p>
                        </div>
                    </div>

                    <div className={helpStyles.policySection}>
                        <h2>General Questions</h2>

                        <div className={helpStyles.faqItem}>
                            <h3>How do I change my location?</h3>

                            <p>
                                The app uses your GPS to show nearby professionals,
                                but you can manually enter a suburb or postcode
                                in the search bar to find experts in another area.
                            </p>
                        </div>

                        <div className={helpStyles.faqItem}>
                            <h3>Is my data safe?</h3>

                            <p>
                                Absolutely. We take privacy seriously.
                            </p>

                            <p>
                                Your personal contact details are only shared
                                with a professional when you choose to contact them
                                or request a quote.
                            </p>

                            <p>
                                Please review our Privacy Policy for full details.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default HelpFaq;